module.exports = __webpack_public_path__ + "static/media/Sunny.9aaaa0d6.jpeg";